import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ConversationProvider } from './contexts/ConversationContext';
import { ConfigSync } from './components/ConfigSync';
import Dashboard from './components/layout/Dashboard';
import AuthCallback from './components/auth/AuthCallback';
import Login from './components/auth/Login';
import { useAuth } from './hooks/useAuth';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="flex space-x-2">
          <div className="w-3 h-3 bg-primary-500 rounded-full loading-dot" />
          <div className="w-3 h-3 bg-primary-500 rounded-full loading-dot" />
          <div className="w-3 h-3 bg-primary-500 rounded-full loading-dot" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <ConversationProvider>
              <ConfigSync />
              <Dashboard />
            </ConversationProvider>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
